export const Constants = {
  TAG_NAME: 'pop-summary-component',
  NESTED_COMPONENTS: [
    'pop-literature-component',
    'pop-key-fact-component',
    'pop-summary-search-component',
  ],
  PRODUCT_NAME_UNAVAILABLE: 'Product name unavailable',
  SUMMARY_SEARCH_PLACEHOLDER: 'Search by ticker, CUSIP, or product name',
  BLANK: '_blank',
  FACT_SHEET: 'Fact Sheet',
} as const;
